<template>
  <div class="paypal_step3">
    <div class="paypal_title">购买记录</div>
    <div class="paypal_cont">
      <p>购买钱包： {{ props.wallet }}</p>
      <p>购买数量： {{ props.buy_number }}</p>
      <p>等值金额： {{ props.usdt }}</p>
      <p>交易ID： {{ props.id }}</p>
      <p>交易状态： {{ result }}</p>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import { getPaypalOrder } from "@/api/index.js"
  
  export default defineComponent({
    name: 'paypal',
    emits: ['setStep'],
    props: {
      id: {
        type: [ String],
        required: true
      },
      wallet: {
        type: [ String],
        required: true
      },
      buy_number: {
        type: [ Number],
        required: true
      },
      usdt: {
        type: [ Number],
        required: true
      },
    },
    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const result = ref('支付查询中，请等待...')
      console.log(props, 'props');
      const getData = async () => {
        const data = await getPaypalOrder({id: props.id, wallet: props.wallet})
        if (data.success) {
          const info = data.content
          const pay_fee = (info.buy_purchase.amount.value - info.buy_transaction_fees - info.buy_usdt) < 0.1
          if (
            info.buy_purchase_status == "COMPLETED" 
            && info.buy_status == "COMPLETED"
            && pay_fee
          ) {
            result.value = '校验完成，代币将在10分钟内转到您的账户，请注意查收！！'
          } else {
            result.value = '交易状态有误，请联系管理员，邮箱地址：service@deeplink.cloud'
          }
          emit('setStep')
        } else {
          result.value = data.msg
        }
      }
      onMounted(async () => {
        await getData()
      })
      return {
        lan,
        result,
        props
      };
    }
  })
</script>

<style scoped lang="scss">
.paypal_step3 {
  width: 100%;
  margin: 0 auto 60px;
  box-sizing: border-box;
  .paypal_title {
    width: 100%;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 40px;
    font-family: Monda;
    text-align: center;
    margin: 60px 0 20px;
  }
  .paypal_cont {
    width: 100%;
    color: #fff;
    font-size: 22px;
  }
}

</style>

<style>
.el-form-item__label {
  color: #fff !important;
}
</style>